﻿import React from 'react';
import { CompositeView, GridView, SimpleView, useRouter } from '@digital/ui';

import { isValidGuid } from '@app/helpers/geradorGuid';

import Minuta from './Minutas';
import MinutaCustomizacao from './MinutaCustomizacao';
import MinutaCustomizada from './MinutaCustomizada';

const Minutas = () => {
  const { history } = useRouter();

  const renderContent = () => {
    switch (history.location.pathname) {
      case '/minutas':
        return <Minuta />;
      case '/minutas/customizacaoDaMinuta':
        return <MinutaCustomizacao />;
      case '/minutas/preencherMinuta':
        return <MinutaCustomizada />;
      default:
        return <Minuta />;
    }
  };

  return <SimpleView>{renderContent()}</SimpleView>;
};

export default Minutas;
